import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from '../../../config/theme';
import Campaign from '../../components/Campaign';
import Typography from '@material-ui/core/Typography';
import InfoMessage from '../../components/InfoMessage';
import CampaignSkeleton from '../../components/CampaignSkeleton';

const useStyles = makeStyles((theme) => ({
  main: {
  },
  mainHeader: {
    textAlign: 'left'
  },
  lightningIcon: {
    top: '7px',
    position: 'relative',
    filter: 'brightness(0) saturate(100%) invert(16%) sepia(97%) saturate(2586%) hue-rotate(222deg) brightness(89%) contrast(101%)',
  },
  title: {
    fontWeight: 700,
    color: '#1A1A1A',
    '& small': {
      fontWeight: 400,
      color: '#666666',
      fontSize: '70%',
      marginLeft: '10px'
    }
  }
}));

export default function Campaigns({ campaigns, loading, currentUser, influencer }) {
  const classes = useStyles();
  const activeCampaigns = React.useMemo(() => {
    if (!campaigns || campaigns.length === 0) return [];
    return campaigns.filter(
      (campaign) => campaign && (campaign["open?"] || campaign.user_status === "waiting_start")
    );
  }, [campaigns]);

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.main}>
        <div className={classes.mainHeader}>
          <Typography variant="h5" className={classes.title}>
            <img src="https://d2zdlj1ifv8u1d.cloudfront.net/images/lightning.svg" className={classes.lightningIcon} />&nbsp;
            Campanhas
            <small>
              Escolha sua sorte
            </small>
          </Typography>
          <br />
        </div>
        {loading &&
          <>
            <CampaignSkeleton mode='first' />
            <CampaignSkeleton mode='list' />
            <CampaignSkeleton mode='list' />
          </>
        }
        <div className={classes.campaigns}>
          {!loading && activeCampaigns.length != 0 && (
            activeCampaigns.map((campaign, index) => (
              <Campaign
                influencer={influencer}
                campaign={campaign}
                currentUser={currentUser}
                key={index}
                mode={index == 0 ? 'first' : 'list'}
                showHeroButton={index != 0}
                showHeroQuickPurchase={index == 0}
              />
            )
          ))}
          {!loading && campaigns.length == 0 && (
            <InfoMessage>Nenhuma campanha encontrada</InfoMessage>
          )}
        </div>
      </div>
    </ThemeProvider>
  )
}
